import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/Main.vue';
import Welcome from '@/Welcome.vue';
// import StripePlayground from '@/StripePlayground.vue';
import Create from '@/views/Create.vue';
import Organization from '@/views/Organization.vue';
import SignUp from '@/views/SignUp.vue';
import SignIn from '@/views/SignIn.vue';
import GettingStarted from '@/views/GettingStarted.vue';
import Dashboard from '@/views/Dashboard.vue';
import WhiteLabel from '@/views/WhiteLabel.vue';
import Teams from '@/views/Teams.vue';
import Users from '@/views/Users.vue';
import Update from '@/Update.vue';

Vue.use(Router);

export default function (store) {
	const router = new Router({
		mode: 'history',
		base: process.env.BASE_URL,
		linkActiveClass: 'active',
		routes: [
			{
				path: '/app/rambox',
				name: 'Update',
				component: Update,
				meta: {
					title: 'nav.update',
				},
			},
			/* {
				path: '/stripeplay',
				name: 'StripePlayground',
				component: StripePlayground,
				meta: {
					title: 'nav.stripePlayground',
					requiresAuth: false,
				},
			}, */
			{
				path: '/',
				name: 'root',
				component: Welcome,
				meta: {
					title: 'nav.welcome',
					requiresAuth: false,
				},
				children: [
					{
						path: '',
						component: Organization,
					},
					{
						path: 'create',
						component: Create,
					},
				],
			},
			{
				path: '/:id',
				// name: 'welcome',
				component: Welcome,
				meta: {
					title: 'nav.welcome',
					requiresAuth: false,
				},
				children: [
					{
						path: 'select',
						// name: 'organization',
						component: Organization,
						meta: {
							title: 'nav.signIn',
						},
					},
					{
						path: 'signup',
						name: 'signup',
						beforeEnter: (to, from, next) =>
							Object.keys(store.state.newUser).length !== 0 ? next() : next({ name: 'root' }),
						component: SignUp,
						meta: {
							title: 'nav.signUpTo',
						},
					},
					{
						path: 'signin',
						component: SignIn,
					},
					{
						path: 'gettingstarted',
						name: 'gettingstarted',
						component: GettingStarted,
					},
				],
			},
			{
				path: '/:id/_',
				name: 'mainLayout',
				redirect: {
					name: 'dashboard',
				},
				meta: {
					requiresAuth: true,
				},
				component: Main,
				children: [
					{
						path: 'dashboard',
						name: 'dashboard',
						component: Dashboard,
						meta: {
							title: 'nav.dashboard',
							requiresAuth: true,
						},
					},
					{
						path: 'whitelabel',
						name: 'whiteLabel',
						component: WhiteLabel,
						meta: {
							title: 'nav.whiteLabel',
							requiresAuth: true,
						},
					},
					{
						path: 'teams',
						name: 'teams',
						component: Teams,
						meta: {
							title: 'nav.teams',
							requiresAuth: true,
						},
					},
					{
						path: 'users',
						name: 'users',
						component: Users,
						meta: {
							title: 'nav.users',
							requiresAuth: true,
						},
					},
				],
			},
		],
	});

	router.beforeEach((to, from, next) => {
		if (to.matched.length === 0) return next({ name: 'root' });
		if (to.matched.some(record => record.meta.requiresAuth)) {
			if (store.getters.isExpired && to.name !== 'dashboard') return next({ name: 'dashboard' });
			if (store.getters.isAuthenticated) return next();
			next('/');
		} else if (store.getters.isAuthenticated) {
			next(`${store.getters.organizationId}/_`);
		} else {
			next();
		}
	});

	return router;
}
